
function prefixStyleSelectorsWithTagName(tagName, style) {
  const textBeforeOpeningBracket = /[^\{\}]+\{/mg;
  return style.replace(
    textBeforeOpeningBracket,
    (selectorString) => prefixSelectors(tagName, selectorString)
  );
}

function prefixSelectors(tagName, selectorString) {
  const prefixedSelectors = selectorString
    .split(/\s?,/)
    .map(selector => selector.trim())
    .map(selector => shouldNotPrefix(selector) ? selector : `${tagName} ${selector}`)
    .map(selector => removeHostSelector(selector))
    .map(selector => fixSlots(selector))
    .join(',\n');
  return `\n\n${prefixedSelectors}`
}

function shouldNotPrefix(selector) {
  return isMediaQuery(selector)
    || isKeyFrame(selector);
}

function isKeyFrame(selector) {
  return selector.startsWith('@keyframes')
    || selector.match(/^[0-9]+%/);
}

function isMediaQuery(selector) {
  return selector.startsWith('@media');
}

function removeHostSelector(selector) {
  return selector
    .replace(/ *\:host\(([^)]+)\)/g, '$1')
    .replace(/ *\:host/g, '');
}

function fixSlots(selector) {
  return selector
    .replace(/\bslot(\s)/,'[slot]$1')
    .replace(/slot\[name=([^\]]+)\]::slotted\(\*\)/, `[slot=$1]`)
    .replace(/slot\[name=([^\]]+)\]::slotted\(([^\)]+)\)/, `$2[slot=$1]`)
    .replace(/slot\[name=([^\]]+)\]/, `[slot=$1]`)
    .replace(/::slotted\(\*\)/, `[slot]`)
    .replace(/::slotted\(([^\)]+)\)/, `$1[slot]`)
}

export default prefixStyleSelectorsWithTagName;
